import LoggedLayout from './LoggedLayout';

export default LoggedLayout;
